module.exports = {
    APIKey: "cbc99f6e"
}